import { render } from "./msgRead.vue?vue&type=template&id=ba532952&scoped=true"
import script from "./msgRead.vue?vue&type=script&lang=js"
export * from "./msgRead.vue?vue&type=script&lang=js"

import "@/styles/striNew.css?vue&type=style&index=0&lang=css"
import "./msgRead.vue?vue&type=style&index=1&id=ba532952&scoped=true&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/tcd-partnerpage-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba532952"]])

export default __exports__